import { Container, Row, Col } from "react-bootstrap";
import styled from 'styled-components';
import Title from '../../../../utils/title/Title';
import { IHeaderType } from '../../../../types/types';
import { Colors } from '../../../../utils/colors/colors';
import ButtonComponent from '../../../../utils/button/ButtonComponent';
import "./Eratek1KBHero.css";
import { useModal } from '../../../../hooks/utils.hook';
import { MediumModal } from '../../../../utils/modals/Modal';
import OneKBInitiativeIntakeForm from '../../../../components/modal-contents/OneKBInitiativeIntakeForm';
import HeroSliders from "./HeroSliders";






export default function Eratek1KBHero() {


  const {
    secondaryColor,
    whiteColor
  } = Colors();


  const {
    open,
    openModal,
    closeModal
  } = useModal();



  return (
    <>
      <section
        id="hero"
        className="section one-kb-hero"
      >
        <Container>
          <Row>
            <Col
              sm={{ span: 12, order: 1 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 12, order: 1 }}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="hero-wrapper"
            >
              <TitleWrapper
                data-aos="fade-up"
                data-aos-once="true"
              >
                <Title
                  textColor={secondaryColor}
                  text={"Empowering Africa's Local Businesses"}
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: "40px",
                  }}
                  type={IHeaderType.h3}
                />
              </TitleWrapper>


              <Text>
                Local businesses are the heartbeat of African communities. Eratek's 1KB Initiative empowers these enterprises, enhancing their visibility and accessibility in the digital world. We believe every business deserves to be seen---and we're making it happen.
              </Text>

              <ButtonComponent
                bgColor={secondaryColor}
                text={"Get Started For Free"}
                click={openModal}
                isLoading={false}
                style={{
                  color: whiteColor,
                  maxWidth: "230px",
                  marginTop: "30px",
                }}
                data-aos="fade-up"
                data-aos-once="true"
              />
            </Col>
          </Row>

        <HeroSliders />
        </Container>




      </section>


      <MediumModal
        open={open}
        showCloseIcon={false}
        openModal={openModal}
        closeModal={closeModal}
        children={<OneKBInitiativeIntakeForm
          closeModal={closeModal}
        />
        }
      />
    </>
  )
};



const TitleWrapper = styled.div`
  display: flex;
  gap: 1rem;
  max-width: 865px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: row
`;

const Text = styled.p`
  max-width: 865px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  color: #4f4f4f;
  color: var(--white-color);
  line-height: 25.6px;
  text-align: center;

  @media (min-width: 1024px) {
    font-size: 1.325rem;
    line-height: 2rem;
  }
`;
